export default [
  {
    icon: 'star',
    color: '#005ed9',
    size: 16,
    position: { top: '30px', left: '-10px' },
    animationDuration: '2.4s',
    animationDelay: '0.5s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { bottom: '-8px', left: '32px' },
    animationDuration: '2.2s',
    animationDelay: '0.2s',
  },
  {
    icon: 'star',
    color: '#1f9bbf',
    size: 16,
    position: { top: '-5px', right: '42%' },
    animationDuration: '2.1s',
  },
  {
    icon: 'star',
    color: '#005ed9',
    size: 16,
    position: { bottom: '-8px', right: '13%' },
    animationDuration: '2.5s',
    animationDelay: '0.7s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 4,
    position: { top: '0', right: '31%' },
    animationDuration: '2.6s',
    animationDelay: '1s',
  },
  {
    icon: 'star',
    color: '#1f9bbf',
    size: 16,
    position: { bottom: '10px', right: '20%' },
    animationDuration: '2.8s',
    animationDelay: '0.1s',
  },
].map((props, key) => ({ ...props, key }));
